import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/main.scss";
import { UserContextProvider } from "./contexts/UserContext";
import { BrowserRouter as Router } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <UserContextProvider>
      <App />
    </UserContextProvider>
  </Router>
);
